module.exports = {"markup":"<span class=\"inline-share-email inline-icon\"><svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M23.363 20.875H8.637v-8.938l6.545 5.687h1.637l6.544-5.687v8.938zm-1.635-9.75L16 16l-5.728-4.875h11.456zM23.363 9.5H8.637L7 11.125v9.75L8.637 22.5h14.727L25 20.875v-9.75L23.363 9.5z\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./static/src/inline-svgs/icon/share-email.svg
// module id = 330
// module chunks = 5 15